import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useConfirmEmailChangeMutation } from 'store/services/segmentsApi';
import { useParseURLQueryParams } from 'utils';

export default function ChangeEmailConfirmation() {
  const { query } = useParseURLQueryParams();
  const history = useHistory();

  const [confirmEmailChange, { isSuccess }] = useConfirmEmailChangeMutation();

  useEffect(() => {
    if (!!!query.token || isSuccess) {
      history.replace('/');
      return;
    }

    confirmEmailChange({ token: query.token });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.token, isSuccess]);

  return (
    <div className="max-w-screen-lg px-16 mx-auto mt-32 mb-14">
      <div>
        <p className="font-bold">Confirming your email...</p>
      </div>
    </div>
  );
}
